import VideoStream from "./VideoStream";

export default VideoStream;